<template>
  <div class="home-child-wrapper">
    <el-container>
      <el-main>
        <div class="main-container">
          <el-tabs
            :tab-position="messageTab"
            v-model="activeName"
            @tab-click="msgTabClick"
          >
            <el-tab-pane name="first">
              <span slot="label"
                ><i class="el-icon-chat-line-round"></i> 聊天消息</span
              >
              <div class="chat-msg-wrap">
                <!-- 会话列表 -->
                <div class="session-container" v-show="sessionArea">
                  <div
                    class="session-loading"
                    v-loading="sessionShade"
                    v-if="conversationList.length == 0"
                  >
                    <span class="no-msg" v-if="!sessionShade">暂无消息</span>
                  </div>
                  <ConverCell
                    @click="sessionClick(session)"
                    v-for="session in conversationList"
                    :key="session.userId"
                    :user="session"
                  />
                </div>
                <div class="chat-container" v-show="chatArea">
                  <!-- 聊天室 -->
                  <ChatRoom @leaveChatRoom="leaveChatRoom" />
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane name="second">
              <!-- <span slot="label" class="left-menu-wrap">
                <i class="el-icon-bell"></i> 系统消息
                <i class="new-msg-flag"></i>
              </span> -->
              <el-badge
                slot="label"
                is-dot
                :hidden="initApplyUnread"
                class="left-menu-wrap"
              >
                <i class="el-icon-bell"></i>系统消息
              </el-badge>
              <div class="system-msg-wrap">
                <!-- 通知列表 -->
                <SystemMessage />
              </div>
            </el-tab-pane>
            <el-tab-pane name="third">
              <span slot="label"
                ><i class="el-icon-chat-dot-square"></i> 评论消息</span
              >
              <div class="comment-msg-wrap">
                <!-- 评论列表 -->
                <CommentCell
                  v-for="(comment, index) in commentList"
                  :key="index"
                  :comment="comment"
                />
                <div class="no-comment" v-if="commentList.length == 0">
                  <span class="no-msg">暂无消息</span>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-main>
      <el-aside width="340px">
        <div class="contact-container">
          <div class="search-wrapper">
            <div class="search-content">
              <el-input
                @focus="this.findInuputFocus"
                placeholder="搜索已添加的好友 / 群"
                prefix-icon="el-icon-search"
                v-model="searchKey"
              >
              </el-input>
              <span
                class="clear-search-btn"
                :class="{ 'btn-on': searchTab }"
                @click="clearSearch"
                title="清空搜索"
              ></span>
            </div>
          </div>
          <div class="search-result" v-if="searchTab">
            <SearchCell
              @click="searchResultClick(friend)"
              v-for="friend in searchResult"
              :key="friend.userID"
              :user="friend"
            />
          </div>
          <div class="relation-wrapper" v-if="relationTab">
            <el-tabs :tab-position="contactTab">
              <el-tab-pane label="好友">
                <el-collapse>
                  <el-collapse-item
                    v-for="(item, index) in contactBook"
                    :key="index"
                  >
                    <template slot="title">
                      {{ item.name }}
                      <span class="member-num">({{ item.member.length }})</span>
                    </template>
                    <div>
                      <FriendCell
                        @click="friendClick(friend)"
                        v-for="friend in item.member"
                        :key="friend.userId"
                        :user="friend"
                      />
                    </div>
                  </el-collapse-item>
                </el-collapse>
                <div class="without-contact" v-show="contactBook.length == 0">
                  <p>暂无好友</p>
                </div>
              </el-tab-pane>
              <el-tab-pane label="群聊">
                <GroupCell
                  @click="groupClick(group)"
                  v-for="group in croupsList"
                  :key="group.groupID"
                  :group="group"
                />
                <div class="without-contact" v-show="croupsList.length == 0">
                  <p>暂无群聊</p>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-aside>
    </el-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import FriendCell from "../components/FriendCell";
import SearchCell from "../components/SearchCell";
import GroupCell from "../components/GroupCell";
import ConverCell from "../components/Conversation";
import SystemMessage from "../components/SystemMessage";
import ChatRoom from "../components/ChatRoom";
import CommentCell from "../components/CommentNotice";
// import { getGroupList, formatMsgTimeStamp } from "../js/chat";
import { apiMap } from "../utils/apiMap";
import qs from "qs";
export default {
  name: "contacts",
  data() {
    return {
      messageTab: "left",
      contactTab: "top",
      activeName: "first",
      groups: [],
      adminSession: [],
      searchKey: "",
      sessionLoading: true,
      sessionShade: true,
      sessionArea: true,
      chatArea: false,
      relationTab: true,
      searchTab: false,
      currentChat: {},
      messageList: [],
      findList: [],
      searchResult: [],
      getAdminTime: 0,
      adminMsgList: [],
    };
  },
  components: {
    ConverCell,
    FriendCell,
    SearchCell,
    GroupCell,
    CommentCell,
    ChatRoom,
    SystemMessage,
  },
  computed: {
    ...mapGetters([
      "conversationList",
      "currentConversation",
      "friendsList",
      "relativesList",
      "workmatesList",
      "schoolmatesList",
      "contactsList",
      "friendGroup",
      "contactBook",
      "croupsList",
      "commentList",
      "adminNotice",
      "handLianApply",
      "copyTreeApply",
    ]),
    showMessageSendBox() {
      return this.currentConversation.type !== this.TIM.TYPES.CONV_SYSTEM;
    },
    initApplyUnread() {
      // console.log(this.handLianApply)
      // console.log(this.copyTreeApply)
      if (this.handLianApply.length == 0 && this.copyTreeApply.length == 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.getCommentMessage(1, 20);
    this.getHandLianApply();
    this.changeSessionShade();
    this.getCopyList(1); //别人向我申请
    this.getCopyList(2); //我向别人申请
    // console.log('-*-*-*-*-*-*-*')
    // console.log(this.contactsList)
    // console.log(this.contactBook)
    // this.contacts = this.contactBook
  },
  methods: {
    findInuputFocus() {
      // console.log(this.contactsList);
      // console.log(this.croupsList);
      // console.log(this.contactBook);
      this.relationTab = false;
      this.searchTab = true;
      if (this.findList.length == 0) {
        let findContainer = new Array();
        this.contactsList.forEach((element) => {
          findContainer.push({
            avatar: element.avatar,
            name: element.name,
            remark: element.remark,
            userID: element.userId.toString(),
            key: element.name + element.remark + element.handNum,
            type: TIM.TYPES.CONV_C2C,
          });
        });

        this.croupsList.forEach((item) => {
          findContainer.push({
            avatar: item.avatar,
            name: item.name,
            remark: "",
            userID: item.groupID,
            key: item.name + item.groupID,
            type: TIM.TYPES.CONV_GROUP,
          });
        });
        this.findList = findContainer;
      }
    },
    clearSearch() {
      this.searchKey = "";
      this.relationTab = true;
      this.searchTab = false;
    },
    filterData() {
      if (this.searchKey === "" || this.searchKey.trim().length === 0) {
        this.searchResult = [];
        return;
      }
      this.searchResult = this.findList.filter((friend) => {
        return friend.key.indexOf(this.searchKey) != -1;
      });
    },
    sessionClick(friend) {
      // console.log(friend);
      this.sessionArea = false;
      this.chatArea = true;
      let targetUser = {
        selType: friend.type,
        selToID: friend.userId,
        selToName: friend.name,
        selToAvatar: friend.avatar,
        sessionID: friend.sessionId,
      };
      this.currentChat = targetUser;
      this.$store.dispatch("setCurrentChat", targetUser);
      if (friend.type === TIM.TYPES.CONV_GROUP) {
        this.getGroupMemberList(friend.userId);
      }
      this.getMessageList(friend);
    },
    getGroupMemberList(groupId) {
      let promise = tim.getGroupMemberList({
        groupID: groupId,
        count: 100,
        offset: 0,
      });
      promise
        .then(function(imResponse) {
          Store.dispatch("setCurrentGroupMenber", imResponse.data.memberList);
        })
        .catch(function(imError) {
          console.warn("getGroupMemberList error:", imError);
        });
    },
    getMessageList(contact) {
      let promise = tim.getMessageList({
        conversationID: contact.sessionId,
        count: 15,
      });
      promise.then(function(imResponse) {
        const messageList = imResponse.data.messageList; // 消息列表。
        // console.log("拉取的消息列表", messageList);
        const nextReqMessageID = imResponse.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
        const isCompleted = imResponse.data.isCompleted; // 表示是否已经拉完所有消息。
        // console.log(nextReqMessageID);
        // console.log(isCompleted);
        let curConversation = {
          messageList: messageList,
          type: contact.type,
          userProfile: {
            avatar: contact.avatar,
            userId: contact.userId,
            userName: contact.name,
          },
          conversationID: contact.sessionId,
          nextReqMessageID: nextReqMessageID,
          isCompleted: isCompleted,
          scrollBottom: true,
        };
        Store.dispatch("setCurrentConversation", curConversation);
        Store.dispatch("clearCurrentUnread", contact.sessionId);
      });
    },
    friendClick(friend) {
      this.sessionArea = false;
      this.chatArea = true;
      this.activeName = "first";
      let targetUser = {
        selType: TIM.TYPES.CONV_C2C,
        selToID: friend.userId.toString(),
        selToName: friend.remark == "" ? friend.name : friend.remark,
        sessionID: TIM.TYPES.CONV_C2C + friend.userId.toString(),
      };
      this.currentChat = targetUser;
      let contactInfo = {
        userId: friend.userId.toString(),
        avatar: friend.avatar,
        name: friend.remark == "" ? friend.name : friend.remark,
        sessionId: TIM.TYPES.CONV_C2C + friend.userId.toString(),
        type: TIM.TYPES.CONV_C2C,
      };
      this.$store.dispatch("setCurrentChat", targetUser);
      this.getMessageList(contactInfo);
    },
    groupClick(friend) {
      this.sessionArea = false;
      this.chatArea = true;
      this.activeName = "first";
      let targetUser = {
        selType: TIM.TYPES.CONV_GROUP,
        selToID: friend.groupID,
        selToName: friend.name,
        sessionID: TIM.TYPES.CONV_GROUP + friend.groupID,
      };
      this.currentChat = targetUser;
      let contactInfo = {
        userId: friend.groupID,
        avatar: friend.avatar,
        name: friend.name,
        sessionId: TIM.TYPES.CONV_GROUP + friend.groupID,
        type: TIM.TYPES.CONV_GROUP,
      };
      this.$store.dispatch("setCurrentChat", targetUser);
      this.getMessageList(contactInfo);
    },
    searchResultClick(friend) {
      this.clearSearch();
      this.sessionArea = false;
      this.chatArea = true;
      this.activeName = "first";
      let targetUser = {
        selType: friend.type,
        selToID: friend.userID,
        selToName: friend.remark == "" ? friend.name : friend.remark,
        sessionID: friend.type + friend.userID,
      };
      this.currentChat = targetUser;
      let contactInfo = {
        userId: friend.userID,
        avatar: friend.avatar,
        name: friend.remark == "" ? friend.name : friend.remark,
        sessionId: friend.type + friend.userID,
        type: friend.type,
      };
      this.$store.dispatch("setCurrentChat", targetUser);
      this.getMessageList(contactInfo);
    },
    leaveChatRoom() {
      this.sessionArea = true;
      this.chatArea = false;
      // 当前会话已读上报
      let preConversationID = this.$store.getters.currentConversation
        .conversationID;
      // console.log(preConversationID)
      if (preConversationID) {
        tim.setMessageRead({ conversationID: preConversationID });
        this.$store.dispatch("clearCurrentUnread", preConversationID);
      }

      this.$store.dispatch("resetCurrentConversation");
    },
    getCommentMessage(start, count) {
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["communityNews"]["method"],
        url: apiMap["communityNews"]["url"],
        data:
          "token=" + loginUser.token + "&start=" + start + "&count=" + count,
      })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            let newList = response.data.result.data.filter((item) => {
              return (
                item.comment !== "praise" &&
                item.commentPraiseUserId !== item.publisherUserId
              );
            });
            // newList.sort((a,b)=>{
            //   return b.commentPraiseDate - a.commentPraiseDate
            // });
            Store.dispatch("pushCommentList", newList);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //获取传连申请列表
    getHandLianApply() {
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["applyList"]["method"],
        url: apiMap["applyList"]["url"],
        params: {
          token: loginUser.token,
        },
      })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            if (response.data.result.data.length != 0) {
              Store.dispatch("pushHandLianAppy", response.data.result.data);
            } else {
              Store.dispatch("pushHandLianAppy");
            }

            // let newList = response.data.result.data;
            // newList.forEach(item=>{
            //   if (!item.relationUserInfo.headImgUrl) {
            //      item.relationUserInfo.headImgUrl = Store.state.defaultAvatar.C2C;
            //   }
            // });
            // console.log(newList)
          } else {
            Store.dispatch("pushHandLianAppy");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    isJsonStr(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (err) {
        return false;
      }
    },
    changeSessionShade() {
      setTimeout(() => {
        if (this.conversationList.length == 0) {
          this.sessionShade = false;
        }
      }, 1500);
    },
    msgTabClick(tab) {
      if (tab.index == "1") {
        this.getAdminMsg();
      }
    },
    getAdminMsg(data) {
      let _this = this;
      var dateNow = Math.round(new Date() / 1000);
      var sevenDay = dateNow - 60 * 60 * 24 * 7;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var params = {
        fromID: "admin",
        toID: loginUser.userId.toString(),
        count: 20,
        start: sevenDay,
        end: dateNow,
      };
      if (!data) {
        data = params;
      }
      _this.getHistoryMsg(data, function(res) {
        //处理管理员消息
        if (res.result.ActionStatus == "OK") {
          _this.getAdminTime += 1;
          let filter = ["503", "504"];
          let allMsg = res.result.MsgList.reverse();
          let adminMsgList = [];
          for (let i in allMsg) {
            const msgType = allMsg[i].MsgBody[0].MsgContent.Data;
            if (filter.includes(msgType)) {
              var noticeContent = allMsg[i].MsgBody[0].MsgContent.Ext;
              var noticeTime = allMsg[i].MsgTimeStamp;
              var noticeType = allMsg[i].MsgBody[0].MsgContent.Data;
              let item = {
                content: noticeContent,
                type: noticeType,
                time: noticeTime,
              };
              adminMsgList.push(item);
              // var msgContent = initAdminMsgContent(noticeType,noticeContent);
              // showAdminNotice(msgContent,noticeTime,noticeType);
            }
          }
          _this.$store.dispatch("pushAdminNotice", adminMsgList);
        }
        let LastMsgKey = res.result.LastMsgKey;
        let MaxTime = res.result.LastMsgTime;
        if (LastMsgKey != "" && res.result.Complete == 0) {
          var reqData = {
            fromID: "admin",
            toID: loginUser.userId.toString(),
            count: 20,
            start: params.start,
            end: MaxTime,
            LastMsgKey: LastMsgKey,
          };
          if (_this.getAdminTime < 15) {
            _this.getAdminMsg(reqData);
          }
        }
      });
    },
    getHistoryMsg(params, okCBK) {
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var requestJson =
        "{\n" +
        '    "From_Account":"' +
        params["fromID"] +
        '",\n' +
        '    "To_Account":"' +
        params["toID"] +
        '",\n' +
        '    "MaxCnt":' +
        params["count"] +
        ",\n" +
        '    "MinTime":' +
        params["start"] +
        ",\n" +
        '    "MaxTime":' +
        params["end"] +
        "\n" +
        "}";
      if (params["LastMsgKey"]) {
        requestJson =
          "{\n" +
          '    "From_Account":"' +
          params["fromID"] +
          '",\n' +
          '    "To_Account":"' +
          params["toID"] +
          '",\n' +
          '    "MaxCnt":' +
          params["count"] +
          ",\n" +
          '    "MinTime":' +
          params["start"] +
          ",\n" +
          '    "MaxTime":' +
          params["end"] +
          ",\n" +
          '    "LastMsgKey":"' +
          params["LastMsgKey"] +
          '"\n' +
          "}";
      }
      var params = {
        token: loginUser.token,
        data: requestJson,
      };
      // var params = qs.stringify(submit,{ encode: false });
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["getHistoryMsg"]["method"],
        url: apiMap["getHistoryMsg"]["url"],
        data: qs.stringify(params, { encode: false }),
      })
        .then(function(response) {
          // console.log(response.data);
          okCBK(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //获取复制家谱申请
    getCopyList(type) {
      //copyTreeList
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let params = {
        token: loginUser.token,
        type: type,
      };
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["copyTreeList"]["method"],
          url: apiMap["copyTreeList"]["url"],
          params: params,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            var applyList = [];
            switch (type) {
              //别人向我申请
              case 1:
                let waitList = response.data.result.data.filter(
                  (item) => item.state == 0
                ); //抽取待我处理的申请
                waitList.forEach(function(item) {
                  applyList.push(item);
                });
                break;

              //我向别人申请
              case 2:
                let agreeList = response.data.result.data.filter(
                  (item) => item.state == 1
                ); //抽取对方同意的申请
                agreeList.forEach(function(item) {
                  applyList.push(item);
                });
                break;
            }
            if (applyList.length > 0) {
              _this.$store.dispatch("pushCopyTreeApply", applyList);
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },

  watch: {
    searchKey() {
      this.filterData();
    },
    conversationList() {
      if (this.conversationList.length == 0) {
        this.sessionShade = false;
      }
    },
  },
};
</script>
<style>
.session-container {
  margin-bottom: 10px;
}

.comment-msg-wrap,
.chat-msg-wrap {
  width: 650px;
}

.comment-msg-wrap .no-comment,
.chat-msg-wrap .session-loading {
  height: 120px;
  text-align: center;
  background-color: #fff;
}

.no-comment .no-msg,
.session-loading .no-msg {
  position: relative;
  display: inline-block;
  margin-top: 83px;
  color: #999;
}

.no-comment .no-msg::before,
.session-loading .no-msg::before {
  position: absolute;
  top: -54px;
  left: -18px;
  width: 100px;
  height: 45px;
  content: "";
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url("../assets/image/cl_no_msg.png");
}

.main-container .el-tabs__active-bar {
  display: none;
}
.el-tabs__nav-wrap::after {
  background-color: #ffffff;
}

.left-menu-wrap .el-icon-bell {
  margin-right: 5px;
}

.left-menu-wrap .el-badge__content.is-fixed.is-dot {
  right: -3px;
  top: 19px;
}

.left-menu-wrap .el-badge__content {
  background-color: #ff5722;
}

.new-msg-flag {
  position: absolute;
  top: 0;
  left: 88px;
  width: 10px;
  height: 10px;
  background-color: #ff0000;
}

.system-msg-wrap {
  width: 650px;
}

.system-msg-wrap .el-tabs__active-bar {
  display: block;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-wrapper .search-content {
  position: relative;
}

.search-content .clear-search-btn {
  display: none;
  position: absolute;
  top: 9px;
  right: 5px;
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.search-content .clear-search-btn.btn-on {
  display: inline-block;
}

.search-content .clear-search-btn::before {
  position: absolute;
  top: 3px;
  left: 2px;
  width: 20px;
  height: 20px;
  content: "";
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url("../assets/icon/cl_clear.png");
}

.contact-container .el-tabs__nav,
.system-msg-wrap .el-tabs__nav {
  width: 100%;
}

.main-container .el-tabs__item {
  width: 190px;
  font-size: 16px;
  text-align: center !important;
  background-color: #fff;
}

.system-msg-wrap .el-tabs__item {
  padding: 0;
}

.contact-container {
  padding: 20px;
  background-color: #fff;
}

/* .contact-container .el-tabs__nav .el-tabs__active-bar {
  width: 50px;
  left: calc(50% - 100px);
} */

.contact-container .el-tabs__nav .el-tabs__item {
  width: 50%;
  padding: 0;
  font-size: 16px;
  text-align: center;
}

.search-result {
  padding-top: 15px;
}

.search-result:empty {
  padding-top: 0;
}

.chat-container {
  width: 650px;
}

.el-collapse-item__header {
  font-size: 16px;
}

.member-num {
  margin-left: 5px;
}

.without-contact {
  text-align: center;
  color: #999;
}
</style>
